import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import "../css/content-page.scss";

const faqs = [
  ["How do I choose the right spice?", "Use each product’s taste, heat, origin and suggested-use notes as a guide. For a specific dish, email our customer care team."],
  ["How should spices be stored?", "Keep them sealed in a cool, dry, dark place. Avoid storing jars directly above a stove or beside a sunny window."],
  ["When will my order ship?", "Processing and estimated delivery details appear in our Shipping & Delivery guide. Timelines can vary by destination and season."],
  ["What if an item arrives damaged?", "Keep the packaging, take a clear photo and contact us with the product name and order reference so we can review it."],
  ["Do you accept returns?", "Food-safety limits may apply to opened ingredients. Read the Returns & Replacements guide for the current conditions."],
  ["How can I contact sickzuno?", "Email harv@sickzuno.online or use the contact form. Please do not send payment-card information."],
];

function Faqs() {
  return (
    <main className="content-page">
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath="/faqs" />
        <article className="content-page__article" aria-labelledby="faqs-title">
          <header className="content-page__header">
            <p className="content-page__eyebrow">Helpful answers</p>
            <h1 id="faqs-title">Frequently Asked Questions</h1>
            <p className="content-page__lead">Quick guidance about ingredients, storage, shipping, returns and support.</p>
          </header>
          {faqs.map(([question, answer], index) => (
            <section className="content-page__section" key={question}>
              <h2>{index + 1}. {question}</h2>
              <p>{answer}</p>
            </section>
          ))}
          <aside className="content-page__support" aria-label="Customer support">
            <div><h2>Still need help?</h2><p>Email harv@sickzuno.online and we’ll point you in the right direction.</p></div>
            <Link className="content-page__inline-link" to="/contact">Contact sickzuno</Link>
          </aside>
        </article>
      </div>
    </main>
  );
}

export default Faqs;
